import { urlManger } from "@/url/common";
import { EntityUrl } from "@intasect/platform-core";
export const url_processingMessage: EntityUrl = {
    get page() {
        return `${urlManger.getServiceUrl("user")}/cmb/message/findLogPage`;
    }
};
